<template>
  <div class="liu-xuan-test-popup-2019">
    <center-popup :show.sync="visible"
                  :close-on-click-modal="false"
    >
      <div class="popup-content no-content"
           v-if="popupType === 'no'"
      >
        <img :src="popupData.src" alt="" >
        <div class="content" v-html="popupData.content"></div>
        <div class="submit-btn"
             @click="handleClickNoDataBtn"
        >
          {{ popupData.btn }}
        </div>
      </div>
      <div class="popup-content yes-content"
           v-else
      >
        <img :src="require('@/pages/2019/LiuXuanTest/assets/img/start/bear_1.png')" alt="" >
        <div class="title">进群前，记得填上你的名字哦</div>
        <form class="input"
              action=""
              @submit.prevent="handleSubmitName"
        >
          <input class="needsclick"
                 type="text"
                 name="name"
                 placeholder="输入你的姓名 (2-7个字)"
                 v-model="name"
                 autofocus
          />
        </form>
        <div class="submit-btn"
             @click="handleSubmitName"
        >确定
        </div>
      </div>
    </center-popup>
    <audio ref="clickVoice"
           :src="require('@/pages/2019/LiuXuanTest/assets/click-voice.mp3')"
           preload="auto"
    ></audio>
  </div>
</template>

<script>
  import { Toast } from 'ym-mint-ui';
  import CenterPopup from '@/components/CenterPopup';

  export default {
    name: 'LiuXuanTestPopup2019',
    components: {
      CenterPopup,
    },
    props: {
      type: {
        type: String,
        required: true,
      },
      show: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        visible: false,
        noData: [
          /* eslint-disable global-require */
          {
            content: '本测试只针对父母，<br/>这种测试就不要凑热闹了',
            src: require('@/pages/2019/LiuXuanTest/assets/img/start/bear_1.png'),
            btn: '不，我要试试',
          },
          {
            content: '你都没孩子测什么？？？',
            src: require('@/pages/2019/LiuXuanTest/assets/img/start/bear_2.png'),
            btn: '不，我不管！',
          },
          {
            content: '你的好奇心和执着感动了我，<br/>点击下方预测你孩子的未来性格吧',
            src: require('@/pages/2019/LiuXuanTest/assets/img/start/bear_3.png'),
            btn: '查看真相',
          },
          /* eslint-enable global-require */
        ],
        popupData: null,
        name: '',
        index: 0,
        popupType: 'no',
      };
    },
    watch: {
      type(val) {
        this.popupType = val;
      },
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
        if (val === false) {
          this.index = 0;
        }
      },
      index(val) {
        if (val < 2) {
          this.popupData = this.noData[val];
        }
      },
    },
    methods: {
      handleClickNoDataBtn() {
        this.$refs.clickVoice.play();
        setTimeout(() => {
          if (this.index === 2) {
            this.popupType = 'yes';
            return;
          }
          this.index += 1;
          this.popupData = this.noData[this.index];
        }, 360);
      },
      handleSubmitName() {
        if (this.name === '') {
          Toast('请先填写你的名字');
          return;
        }
        if (this.name.length > 7) {
          Toast('名字最多只能7个字，请删减后重试');
          return;
        }
        if (this.name.length < 2) {
          Toast('名字最少要2个字，请增加后重试');
          return;
        }
        this.$emit('userName', this.name);
        this.visible = false;
      },
    },
    created() {
      const { noData, index } = this;
      this.popupData = noData[index];
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  /deep/ .popup-content, /deep/ .center-popup {
    width: 500px;
    height: 350px;
  }

  .popup-content {
    position: relative;
    width: 500px;
    height: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url('~@/pages/2019/LiuXuanTest/assets/img/start/popup_bg.png') no-repeat;
    background-size: contain;
    img {
      position: absolute;
      width: 136px;
      height: 136px;
      display: block;
      top: -68px;
      left: 182px;
    }
  }

  .no-content {
    justify-content: space-between;
    .content {
      margin-top: 85px;
      font-size: 26px;
      color: #333;
      line-height: 1.8;
    }
    .submit-btn {
      position: relative;
      width: 418px;
      height: 56px;
      margin-top: 34px;
      margin-bottom: 56px;
      line-height: 56px;
      text-align: center;
      color: @color-white;
      font-size: @font-size-base;
      border-radius: 28px;
      background: #36aba8;
      &:before {
        display: block;
        content: '';
        position: absolute;
        width: 460px;
        height: 1px;
        background: #36aba8;
        top: -34px;
        left: -@size-small;
      }
    }
  }

  .yes-content {
    padding-top: 80px;
    box-sizing: border-box;
    .title {
      margin-bottom: 34px;
      font-size: 26px;
      color: #333;
      line-height: 1;
    }
    .input {
      display: flex;
      flex-direction: column;
      color: @color-text-light;
      font-size: 26px;
      line-height: 1;
      input {
        outline: none;
        display: block;
        margin-top: 8px;
        padding-left: @size-extra-small;
        box-sizing: border-box;
        width: 396px;
        height: 70px;
        background: #e1e1e1;
        border: none;
        &::placeholder {
          color: #b9b9b9;
        }
      }
    }
    .submit-btn {
      width: 418px;
      height: 56px;
      margin-top: 30px;
      line-height: 56px;
      text-align: center;
      color: @color-white;
      font-size: @font-size-base;
      border-radius: 28px;
      background: #36aba8;
    }
  }
</style>
